import api from "PFCore/api";
import { UpcomingBooking } from "PFTypes";

export type UpcomingBookingsResponse = { entries: UpcomingBooking[] };

export const fetchNextBookings = () => api<UpcomingBookingsResponse>({ url: "marketplace/next_bookings" });
